import { useIdentity } from "../auth/useIdentity";
import { config, flagEnabled } from "../config";
import { useProviders } from "../modules/providers/useProviders";
import { useProviderKind } from "../modules/providers/useProviderKind";
import { navGroups, type NavGroup } from "./nav";

/**
 * The sidebar's groups for this login, in this namespace. The sidebar and the
 * Reports category pages read the same answer, so a page never lists a report
 * the sidebar would hide.
 */
export function useNavGroups(): NavGroup[] {
  const identity = useIdentity();
  const { direct } = useProviders();
  const providerType = useProviderKind();
  return navGroups(
    flagEnabled,
    identity.roles,
    config().phpPortalBase,
    direct.map((p) => ({ namespace: p.namespace, name: p.name })),
    providerType,
    identity.namespace,
  );
}
